import { demoAnchorMonday, fmtMonthDay } from './demoAnchor';

export type UserPersona = 'ramiro' | 'newbie';

export type User = {
  id: UserPersona;
  displayName: string;
  /** Single character for Avatar. */
  initial: string;
  /** Date line shown in greeting: "Mon · Apr 20 · Los Altos". */
  dateLine: string;
  /** Short location string used in sidenav me-block: "base week 2". */
  weekLabel: string;
};

// PR-G (DD-6/E5) — the greeting date line derives from the demo "today"
// (the current week's Monday) instead of a frozen 'Mon · Apr 20'.
const demoDateLine = `Mon · ${fmtMonthDay(demoAnchorMonday())} · Los Altos`;

// Ramiro — happy path. Data modelled on the real athlete_context we have
// for this user, trimmed to what the dashboard surface actually consumes.
export const ramiro: User = {
  id: 'ramiro',
  displayName: 'Ramiro',
  initial: 'R',
  dateLine: demoDateLine,
  weekLabel: 'base week 2',
};

// Newbie — brand-new signup, no plan yet. Triggers the setup-first skin
// everywhere (<TodayHero variant="firstRun">, NoPlan championship,
// day-0 streak, onboarding_incomplete coach state). Resolver in
// useQueryState.ts forces coach='onboarding_incomplete' and race='none'
// when user='newbie'.
export const newbie: User = {
  id: 'newbie',
  displayName: 'Ramiro',
  initial: 'R',
  dateLine: demoDateLine,
  weekLabel: 'new runner',
};
